import { computed } from '@vue/composition-api'

export default function useMe(root) {
  const me = computed(() => root.$store.getters.me)
  return { me: me.value }
}
